import {
    Orientation,
    PlayerUsageType,
    RemoteMode,
} from '@kinopoisk-int/evgen-web-events/web/named_enums';
import { playerNavigatedV3, PlayerNavigatedV3To } from '@kinopoisk-int/evgen-web-events/web/player';

import { useEventCallbackWithoutBuilder } from '@/scenarios/legacy-player/hooks/analytics/use-event-callback-without-builder';

interface Options {
    channelId: string;
    vsid?: string;
    psid?: string;
}

export function useChannelProgramNavigated(params: Options) {
    const handleNavigated = useEventCallbackWithoutBuilder({
        event: playerNavigatedV3,
        uiParams: {
            orientation: Orientation.Horizontal,
            remoteMode: RemoteMode.Disabled,
            vsid: params.vsid ?? 'NONE',
            usageType: PlayerUsageType.Button,
            to: PlayerNavigatedV3To.TvProgramScreen,
        },
    });

    return handleNavigated;
}
